import axios from 'axios'

const MEDIA_OBJECT_CACHE_LIMIT = 120
const mediaObjectCache = new Map<string, string>()
const pendingMediaObjects = new Map<string, Promise<string>>()
let mediaCacheGeneration = 0

const rememberMediaObject = (key: string, objectUrl: string) => {
    mediaObjectCache.delete(key)
    mediaObjectCache.set(key, objectUrl)

    while (mediaObjectCache.size > MEDIA_OBJECT_CACHE_LIMIT) {
        const oldest = mediaObjectCache.entries().next().value as [string, string] | undefined
        if (!oldest) break
        mediaObjectCache.delete(oldest[0])
        URL.revokeObjectURL(oldest[1])
    }
}

export const getSecureMediaObjectUrl = async (source: string) => {
    const cached = mediaObjectCache.get(source)
    if (cached) {
        mediaObjectCache.delete(source)
        mediaObjectCache.set(source, cached)
        return cached
    }

    const pending = pendingMediaObjects.get(source)
    if (pending) return pending

    const requestGeneration = mediaCacheGeneration
    const request = axios.get(source, {
        responseType: 'blob'
    }).then((response) => {
        const objectUrl = URL.createObjectURL(response.data)
        if (requestGeneration !== mediaCacheGeneration) {
            URL.revokeObjectURL(objectUrl)
            throw new Error('The Services media session has ended.')
        }
        rememberMediaObject(source, objectUrl)
        return objectUrl
    }).finally(() => {
        pendingMediaObjects.delete(source)
    })

    pendingMediaObjects.set(source, request)
    return request
}

export const clearSecureMediaObjectCache = () => {
    mediaCacheGeneration += 1
    mediaObjectCache.forEach((objectUrl) => URL.revokeObjectURL(objectUrl))
    mediaObjectCache.clear()
    pendingMediaObjects.clear()
}
